import { render, staticRenderFns } from "./rep_trimestre.vue?vue&type=template&id=3adf972a&"
import script from "./rep_trimestre.vue?vue&type=script&lang=ts&"
export * from "./rep_trimestre.vue?vue&type=script&lang=ts&"
import style0 from "./rep_trimestre.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports